module.exports = __webpack_public_path__ + "static/media/traintest.ab3ecb9d.png";